import { Injectable } from '@angular/core';
import { BuildProcessTypeId } from '@App/app/entities/processing/build-process-status.model';
import { BuildProcess } from '@App/app/entities/processing/build-process.model';
import { ModelsProcessingService } from '@App/app/pages/processing/services/models-processing-service/models-processing.service';
import { ReportProblemDialogComponent } from '@App/app/shared/components/report-problem-dialog/report-problem-dialog/report-problem-dialog.component';
import { NbDialogService } from '@nebular/theme';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, take } from 'rxjs/operators';

@UntilDestroy({ checkProperties: true })
@Injectable()
export class ProcessingSidebarRetryService {
  private currentBuildProcess: BuildProcess;

  constructor(
    private modelsProcessingService: ModelsProcessingService,
    private dialogService: NbDialogService,
  ) {
    this.modelsProcessingService.currentBuildProcess
      .pipe(untilDestroyed(this), filter<BuildProcess>(Boolean), take(1))
      .subscribe((process) => {
        this.currentBuildProcess = process;
      });
  }

  checkRetryCounterExceeded(): any {
    return this.currentBuildProcess.retryCounter >= 2;
  }

  showProblemReport() {
    this.dialogService.open(ReportProblemDialogComponent, {
      context: {
        category: 'processing',
        subcategory: this.getProblemReportSubcategory(),
        title: `Cannot proceed with processing #${this.currentBuildProcess.id}`,
        description: `The process with id: ${this.currentBuildProcess.id} has been retried too many times and cannot be processed further. Assistance needed.`,
      },
    });
  }

  private getProblemReportSubcategory(): string {
    const map = {
      [BuildProcessTypeId.AT]: 'aeroTriangulation',
      [BuildProcessTypeId.Prod]: 'production',
      [BuildProcessTypeId.PP]: 'postProcessing',
    };

    return map[this.currentBuildProcess.buildProcessTypeId as 2 | 4 | 5];
  }
}
